import { render, staticRenderFns } from "./AddAttributeDefinitionTemplateWizardControl.global.vue?vue&type=template&id=4050440c&lang=pug&"
import script from "./AddAttributeDefinitionTemplateWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddAttributeDefinitionTemplateWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports